import s from './CloudBand.module.css';

/**
 * CloudBand — single cloud decoration element for all screens.
 * Source of truth: Figma 2080:2107. Natural size: 1440×149px.
 *
 * Props:
 *   variant    'orange' | 'cream' | 'teal' | 'teal-800'. Selects the SVG file. Default: 'orange'.
 *              teal     = #2ab8a8 (teal/1000) — use when background below is standard teal
 *              teal-800 = #5bd9cb (teal/800)  — use when background below is teal-800
 *   className  Page-level class for vertical positioning (top / bottom value).
 *
 * Implementation note: uses background-image repeat-x instead of <img> so the
 * cloud pattern tiles at its natural 1440px width on any viewport, never clipping.
 */
export default function CloudBand({ variant = 'orange', className = '' }) {
  const src =
    variant === 'cream'
      ? '/assets/cloud-band-cream.svg'
      : variant === 'teal'
        ? '/assets/cloud-band-teal.svg'
        : variant === 'teal-800'
          ? '/assets/cloud-band-teal-800.svg'
          : '/assets/cloud-band-orange.svg';

  return (
    <div
      className={`${s.wrapper} ${className}`.trim()}
      style={{ backgroundImage: `url('${src}')` }}
      aria-hidden="true"
    />
  );
}
